module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lobby-theme-footer"
  }, [_c('div', {
    staticClass: "lobby-theme-footer-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "footer-inner"
  }, [_c('div', {
    staticClass: "visible-pc"
  }, [_c('div', {
    staticClass: "mt10"
  }, [_vm._v(_vm._s(_vm.$store.state.copyright))]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$store.state.address) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "visible-mobile"
  }, [_c('div', {
    staticClass: "mt10"
  }, [_vm._v(_vm._s(_vm.$store.state.copyright))]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$store.state.address) + "\n\t\t\t\t\t\t\t")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-cb088ab2"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/theme/widget/FooterView.vue
// module id = 1025
// module chunks = 1